// extracted by mini-css-extract-plugin
export default {"cards":"ClientsCRUD_cards__1+tSN","controls":"ClientsCRUD_controls__G3Mc9"};